module.exports = __webpack_public_path__ + "img/gj-btn.8c786113.png";